module.exports = __webpack_public_path__ + "static/media/kairos-logo-white.4ac2ddb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/kairos-logo-white.svg
// module id = 400
// module chunks = 0